import {
  getPackages,
} from "../api/bernabeu";

import {
  packageSlice,
  callTypes
} from "../../redux/reducers/packageSlice";

const { actions } = packageSlice;

export const fetchPackages = (branchId, type, modality = '', couponId = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params: any = {
      type: type,
    };

    if (modality) {
      params.modality = modality;
    }

    if (couponId) {
      params.coupon_id = couponId;
    }

    getPackages(branchId, params)
      .then((response : any) => {
        resolve(response.data);

        dispatch(actions.packagesFetched());
      })
      .catch(error => {
        error.clientMessage = "Not found";
        dispatch(actions.catchError({ error, callType: callTypes.list }));
        dispatch(actions.packagesFetched());

        reject(false);
      });
  });
};